<template>
  <div class="search-result-card-wrapper disbursement">
    <div class="search-result-card-section-group left">
      <div class="group">
        <div class="search-result-card-section" id="borrowername">
          <div
            class="borrower-name"
            :title="decodeHTMLEncodedStr(disbursement.borrowerFullName)"
          >
            {{
              decodeHTMLEncodedStr(disbursement.borrowerFullName) || "No Name"
            }}
          </div>
        </div>

        <div class="search-result-card-section" id="status">
          <div class="xcertificationstatus">
            {{ disbursement.disbursementStatusTypeName }}
          </div>
        </div>
      </div>
      <div class="group">
        <div class="search-result-card-section referenceid" id="referenceid">
          <h5 class="icon icon-single-person" :title="disbursement.referenceId">
            {{ disbursement.referenceId }}
          </h5>
        </div>
        <div class="search-result-card-section" id="amount">
          <span>{{ disbursement.disbursementAmountFormatted }}</span>
        </div>
      </div>
      <div class="search-result-card-section lender" id="lender">
        <h5 class="icon icon-hand-shake" :title="disbursement.lenderName">
          {{ disbursement.lenderName }}
        </h5>
      </div>

      <div class="group disbursement-details">
        <div
          class="search-result-card-section disbursementDate"
          id="disbursementDate"
        >
          <h5 class="icon icon-calendar-checkmark">
            {{ disbursement.disbursementDateDisplay }}
          </h5>
        </div>
        <div
          class="search-result-card-section disbursementMethod"
          id="disbursementMethod"
        >
          <h5 class="icon icon-bank-arrow-right">
            {{ disbursement.disbursementMethodTypeDescription }}
          </h5>
        </div>
      </div>

      <div
        v-if="showCreatedDate"
        class="search-result-card-section"
        id="createdatutc"
      >
        <span style="color: red">{{ disbursement.createdAtUtc }}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { PropType } from "vue";
import useFunctions from "@/use/functions1";
import { useDebugDateKey } from "@/composables/useDebugDateKey";

const { decodeHTMLEncodedStr } = useFunctions();
const { showCreatedDate } = useDebugDateKey();

const props = defineProps({
  disbursement: {
    type: Object as PropType<any>,
    required: true,
  },
});
</script>

<style scoped src="@/assets/css/search-page/search-page-result-card.css" />
